export const DOCUMENTS_QUERY_KEY = 'documents';
export const GENERAL_DOCUMENTS_QUERY_KEY = 'general-documents';
export const DOCUMENTS_FOLDERS_QUERY_KEY = 'documents-folders';
